import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { logger } from "../lib/logger";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => {
        try { return localStorage.getItem("vmtips_theme") || "dark"; }
        catch (e) {
            logger.warn("theme: localStorage read failed", e);
            return "dark";
        }
    });

    const setTheme = useCallback((next) => {
        const v = next === "light" ? "light" : "dark";
        setThemeState(v);
        try { localStorage.setItem("vmtips_theme", v); }
        catch (e) { logger.warn("theme: localStorage write failed", e); }
    }, []);

    const toggle = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [theme, setTheme]);

    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove("light", "dark");
        root.classList.add(theme);
    }, [theme]);

    const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);
    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error("useTheme must be inside <ThemeProvider>");
    return ctx;
}
